<template>
  <div class="serve-item">
    <div class="international-box">
      <Title v-if="title" :title="title" :titleType="titleType" :src="url" @TitleFun="TitleFun"></Title>
      <ul>
        <li class="news-li-border" v-for="(item, index) of newsList" :key="index">
          <div class="news-li" :class="item.url ? 'link' : 'no-link'">
            <div class="news-left" style="width: 65%;" @click="itemClick(item)">{{item.title}}</div>
            <div class="news-time">{{item.publishTime}}</div>
          </div>
        </li>
      </ul>
    </div>
        <el-dialog
      title="工作简历"
      :visible="show"
      width="600px"
      :close-on-click-modal="false"
      :show-close="true"
      @close="resumeClear1"
    >
     您暂未通过入会申请，请先完成入会申请后，方可查看
       <span slot="footer">
        <el-button
          type="primary"
          size="medium"
          @click.native.prevent="AmendSubmits"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script lang="js">
import Title from './Title.vue';

export default {
  components: {
    Title,
  },
  props: {
    title: [String, Array],
    titleType: String,
    url: String,
    column: String,
    list: Array,
    list1: Array,
  },
  data() {
    return {
      newsList: [],
      show: false,
      num: 0,
    };
  },
  watch: {
    list(n, o) {
      this.newsList = n;
    },
  },
  created() {
    if (this.list.length > 0) {
      this.newsList = this.list;
    }
  },
  methods: {
    TitleFun(ind) {
      this.num = ind;
      if (ind > 0) {
        this.newsList = this.list1;
      } else {
        this.newsList = this.list;
      }
    },
    itemClick(item) {
      const user = window.localStorage.getItem('userPermissions');
      let Permissions = user ? user.toString() : null;
      if (Permissions === '1') {
        // 判断this.title是否字符串和数组
        if (typeof this.title === 'string') {
          this.$emit('ServeItemFun', {
            item,
            column: this.column,
          });
        } else if (Array.isArray(this.title)) {
          if (this.num == 1) {
            this.$emit('ServeItemFun', {
              item,
              column: this.column,
            });
          } else {
            this.$emit('ServeItemFun', {
              item,
              column: 'referencedata',
            });
          }
          
        }

        // console.log(this.column,this.title);
        // this.$emit('ServeItemFun', {
        //   item,
        //   column: this.column,
        // });
      } else {
        this.show = true;
      }
    },
    AmendSubmits() {
      this.$router.push('/apply/unit');
    },
    resumeClear1() {
      this.show = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.serve-item{
  padding: 5px;
  // background-color: #155BDD;
}
.international-box{
  background-color: #ffffff;
  border-radius: 6px;
  position: relative;
  padding: 5px 15px 15px 15px;
  min-height: 271px;
}
.news-li-border{
  border-bottom: 1px dashed  #E9E9E9
}
.news-li{
  position: relative;
  padding: 12px 0px 12px 22px;
  line-height: 16px;
}
.no-link::before{
  content: '';
  position: absolute;
  width: 20px;
  height: 22px;
  background-image: url("../../assets/images/artical.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  top: 9px;
  left: -4px;
}
.link::before{
  content: '';
  position: absolute;
  width: 20px;
  height: 22px;
  background-image: url("../../assets/images/link.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  top: 9px;
  left: -4px;
}
.news-left{
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  color: #474747;
}
.news-left:hover{
  color: #1E63B0;
}
.news-time{
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  line-height: 14px;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 10px;
  color: #999;
}
</style>
